export default "__VITE_ASSET__5343a6f3__"